<template>
  <div class="" v-loading="loading">
    <back />

    <div class="title">{{ add ? "发布消息" : "修改消息" }}</div>

    <div class="form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
        <el-row type="flex" justify="">
          <el-col :span="10">
            <el-form-item label="标题" prop="title">
              <el-input v-model="ruleForm.title" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="排序" prop="sortNum">
              <el-input v-model="ruleForm.sortNum" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row type="flex" justify="">
          <el-col :span="22">
            <el-form-item label="消息内容" prop="content">
              <editor :htmls="ruleForm.content" @change="onChange" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="btn">
        <el-button type="primary" @click="submitForm('ruleForm')" :loading="submitLoding">{{ add ? "发布" : "修改" }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import editor from "@/components/editor.vue"
function createInitRuleForm() {
  return {
    title: "",
    // sortNum: "",
    content: "",
  }
}
export default {
  components: { editor },
  data() {
    return {
      loading: false,
      submitLoding: false,

      add: false,
      ruleForm: createInitRuleForm(),
      rules: {
        title: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // sortNum: [{ required: true, message: "请输入内容", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "submit" }],
      },
    }
  },
  created() {
    this.add = this.$route.query.add == "1" ? true : false
    if (!this.add) {
      this.getInfo()
    }
  },
  methods: {
    getInfo() {
      this.loading = true
      this.$axios
        .get(this.$api.noticeInfoselectDetail, {
          params: {
            id: this.$route.query.id,
          },
        })
        .then(res => {
          this.ruleForm = res.result
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    onChange(value) {
      this.ruleForm.content = value
    },
    // 提交表单
    submitForm(formName) {
      this.submitLoding = true
      let params = Object.assign({}, this.ruleForm)
      let api = ""
      let methods = ""
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.add) {
            api = this.$api.noticeInfoinsert
            methods = "post"
          } else {
            api = this.$api.noticeInfoupdate
            methods = "post"
          }
          this.$axios[methods](api, params)
            .then(res => {
              this.$message.success(`${this.add ? "发布" : "修改"}成功`)
              this.submitLoding = false
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            })
            .catch(err => {
              this.submitLoding = false
              this.$message.error(err.desc)
            })
        } else {
          this.submitLoding = false
          this.$message.error("提交失败")
          return false
        }
      })
    },
    // 重置校验
    resetForm() {
      this.ruleForm = createInitRuleForm()
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="scss">
.title {
  font-size: 18px;
  font-weight: bold;
  margin: 20px 0 40px;
}
.btn {
  text-align: center;
  margin: 40px 0;
  .el-button {
    min-width: 120px;
  }
}
</style>
